import React from "react";
import { LuSearch, LuExternalLink, LuGlobe } from "react-icons/lu";

import { BASE_URL_PREVIEW } from "../../api/ApiEndpoints";

export default function SearchPreview({ result }) {
  if (!result?.url) {
    return (
      <div className="flex h-full min-h-[420px] items-center justify-center rounded-xl border border-slate-200 bg-white shadow-sm">
        <div className="max-w-sm px-6 text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
            <LuSearch size={24} />
          </div>

          <h2 className="mt-4 text-[15px] font-semibold text-slate-700">
            Select a search result
          </h2>

          <p className="mt-1 text-[12px] leading-5 text-slate-400">
            Click a search result from the left side to preview it here.
          </p>
        </div>
      </div>
    );
  }

  const normalizedBaseUrl = (BASE_URL_PREVIEW || "").replace(/\/$/, "");

  const previewUrl = `${normalizedBaseUrl}/search/preview?url=${encodeURIComponent(
    result.url,
  )}`;

  return (
    <div className="flex h-full min-h-[420px] flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      {/* Preview Header */}
      <div className="flex shrink-0 items-center gap-3 border-b border-slate-200 bg-white px-4 py-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50 text-slate-500">
          <LuGlobe size={16} />
        </div>

        <div className="min-w-0 flex-1">
          <h2 className="truncate text-[13px] font-semibold text-slate-800">
            {result.title || result.displayUrl || result.url}
          </h2>

          <p className="truncate text-[11px] text-emerald-600">
            {result.displayUrl || result.url}
          </p>
        </div>

        <button
          type="button"
          onClick={() => {
            window.location.href = result.url;
          }}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-[11px] font-medium text-slate-600 transition hover:bg-slate-50 hover:text-slate-800"
        >
          Open Website
          <LuExternalLink size={12} />
        </button>
      </div>

      {/* Website Preview */}
      <div className="relative min-h-0 flex-1 bg-white">
        <iframe
          key={previewUrl}
          src={previewUrl}
          title={result.title || "Website preview"}
          className="absolute inset-0 h-full w-full border-0"
        />
      </div>
    </div>
  );
}
